import React from 'react';
import { useDispatch } from 'react-redux';
import { setActiveCategory, setCurrentPage } from '../storage/store';
import { useNavigate } from 'react-router-dom';

const Category = ({ selectedCategory }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const activeCategory = selectedCategory?.toUpperCase() || 'ALL';

  const handleCategoryClick = (category) => {
    dispatch(setActiveCategory(category));
    dispatch(setCurrentPage(1));
    navigate(`/${category.toLowerCase()}`);
    console.log(`Clicked category: ${category}`);
  };

  return (
    <div className="matchCategory">
      <ul className="matchListCategory" id="listCategory">
        {[
          { key: 'all', label: 'ALL', icon: 'all_icon' },
          { key: 'CRICKET', label: 'CRICKET', icon: 'cricket_icon' },
          { key: 'FOOTBALL', label: 'FOOTBALL', icon: 'football_icon' },
          { key: 'BASKETBALL', label: 'BASKETBALL', icon: 'basketball_icon' },
          { key: 'TENNIS', label: 'TENNIS', icon: 'tennis_icon' },
          { key: 'ESPORTS', label: 'ESPORTS', icon: 'esport_icon' }
        ].map(({ key, label, icon }) => (
          <li
            key={key}
            onClick={() => handleCategoryClick(label)}
            className={`matchFilter ${activeCategory === label ? 'active' : ''}`}
            data-category={label}
          >
            <img decoding="async" src={`/img/${icon}.svg`} alt={`${label} Icon`} />
            {label}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Category;
